"use client";

import { useState } from "react";
import Preloader from "@/components/preloader";

/**
 * Client gate that manages preloader lifecycle.
 * Mounts the Preloader on first render, unmounts after onComplete.
 */
export default function PreloaderGate() {
  const [show, setShow] = useState(true);

  if (!show) return null;

  return <Preloader onComplete={() => setShow(false)} />;
}
